import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import IntakeForm from '../components/IntakeForm';
import { saveAudit, generateId, getAudit } from '../utils/storage';
import { supabase } from '../utils/supabase';
import { createDefaultScores, createDefaultRevenuLeaks, createDefaultMemoryTest, createDefaultSocialProof, createDefaultBrandCoherence } from '../utils/scoring';

export default function NewAudit() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reauditId = searchParams.get('reaudit');
  const [existingAudit, setExistingAudit] = useState(null);

  useEffect(() => {
    if (reauditId) {
      getAudit(reauditId).then(setExistingAudit);
    }
  }, [reauditId]);

  const handleIntakeComplete = async (data) => {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();

    const audit = {
      id: generateId(),
      intake: data,
      scores: createDefaultScores(),
      revenueLeaks: createDefaultRevenuLeaks(),
      memoryTest: createDefaultMemoryTest(),
      socialProof: createDefaultSocialProof(),
      brandCoherence: createDefaultBrandCoherence(),
      previousAuditId: reauditId || null,
      createdBy: user?.id || null,
      createdByName: user?.user_metadata?.full_name || user?.email || null,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      status: 'draft',
    };
    // Save to localStorage IMMEDIATELY so Dashboard can find it
    try {
      const local = JSON.parse(localStorage.getItem('whats_next_audits') || '[]');
      local.unshift(audit);
      localStorage.setItem('whats_next_audits', JSON.stringify(local));
    } catch(e) {}
    // Save to Supabase in background
    saveAudit(audit).catch(err => console.warn('Save failed:', err.message));
    // Navigate immediately
    navigate(`/dashboard/${audit.id}`);
  };

  return (
    <div className="max-w-2xl mx-auto py-8">
      <div className="text-center mb-10">
        <h1 className="font-display text-2xl text-white mb-1">
          {existingAudit ? 'Re-Audit' : 'New Business Audit'}
        </h1>
        <p className="text-sm text-neutral-400">
          {existingAudit
            ? `Updating assessment for ${existingAudit.intake?.conceptName}`
            : "Tell us about the concept you're evaluating"}
        </p>
      </div>
      <IntakeForm onComplete={handleIntakeComplete} existingAudit={existingAudit} />
    </div>
  );
}
